import React, { FC } from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';

type Props = {
  record: any;
};

const AnnotationStandardActionColumn: FC<RouteComponentProps & Props> = ({ history, record }) => {
  return (
    <>
      {record.canEdit && (
        <span>
          <Link to={`/annotation-manager/annotation-standards/${record.id}`}>Edit</Link>
        </span>
      )}
    </>
  );
};

export default withRouter(AnnotationStandardActionColumn);
